module.exports = __webpack_public_path__ + "static/img/8301_phase_function_Paper_Points.685e3a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/8301_phase_function_Paper_Points.png
// module id = iHGm
// module chunks = 0